var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_star_0",
    d: "M10.368.695,7.927,5.866,2.466,6.7A1.266,1.266,0,0,0,1.8,8.831l3.951,4.023-.935,5.683a1.207,1.207,0,0,0,1.735,1.316l4.886-2.683,4.886,2.683a1.208,1.208,0,0,0,1.735-1.316l-.935-5.683,3.951-4.023A1.266,1.266,0,0,0,20.417,6.7l-5.462-.832L12.514.695A1.175,1.175,0,0,0,10.368.695Z",
    transform: "translate(-1.441 0.001)",
    fill: "#dfe3eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar0);
export default __webpack_public_path__ + "static/media/star_0.dabf2fbbec5284c216ff8e9415a871f4.svg";
export { ForwardRef as ReactComponent };